import { render, staticRenderFns } from "./IndagineEpidemiologicaLegionellosiEditComponent.vue?vue&type=template&id=57ccd8b0"
import script from "./IndagineEpidemiologicaLegionellosiEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaLegionellosiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports